module.exports = __webpack_public_path__ + "static/media/clipboard.dbce7140.svg";